// extracted by mini-css-extract-plugin
export default {"bannerHeader":"style_bannerHeader__7GhM2","directorsSection":"style_directorsSection__FRqiN"};